import React, { useState, useCallback, useEffect } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import './feasibility-id.scss';
import { NetworkStatus } from '../network-status/network-status';
import { CreateNewFeasibilityPayLoad, FeasibilityResponseType, formSchema } from './formControl';
import { checkOftFeasibilityStatusDedicated } from 'common/helper/api.helper';
import { handleError } from 'common/utils/app.utils';
import Button from 'b2b-ui-components-lib/lib/components/button';
import debounce from 'lodash.debounce';
import { v4 as uuidv4 } from 'uuid';
import { createNewFeasibilityFromId } from 'common/services/http.service';
import { GENERIC_ERROR_MESSAGE, getProductType } from 'common/constants/app.constants';
import { FEASIBILITY_STATUS_SCHEMA } from 'singleSite/network-status/network-constant';
import { FEASBILITY_MESSAGE, feasibility_type } from './feasibility-constants';

type Props = {
  setShowFeasibilityId: Function;
  processFeasibilityResponse: Function;
  // setInstAddressValidated: Function;
};

// export const FeasibilityID: React.FC<Props> = ({ setShowFeasibilityId, processFeasibilityResponse, setInstAddressValidated }: Props) => {
export const FeasibilityID: React.FC<Props> = ({ setShowFeasibilityId, processFeasibilityResponse }: Props) => {
  const [form, setForm] = useState<typeof formSchema>(formSchema);
  const [feasibilityResponse, setFeasibilityResponse] = useState<FeasibilityResponseType | null>();
  const [errorMessage, setErrorMessage] = useState<null | string>(null);
  const [showLoader, setShowLoader] = useState(false);

  const resetState = () => {
    setErrorMessage(null);
    setFeasibilityResponse(null);
    // setInstAddressValidated(false);
  };

  useEffect(() => {
    if (!form.feasibilityId.value) {
      resetState();
    }
  }, [form.feasibilityId.value]);

  const getFeasibilityMessage = (messages: string, productType: string) => {
    if (!messages) return '';
    let feasibilityMessage = '';
    let messageArr: Array<string> = messages.split('|').map((message) => message.trim());
    for (let i = 0; i <= messageArr.length; i++) {
      if (messageArr[i] === feasibility_type.PRODUCT_MISMATCH) {
        feasibilityMessage = FEASBILITY_MESSAGE[feasibility_type.PRODUCT_MISMATCH] + ' ' + productType;
        return feasibilityMessage;
      }
      if (FEASBILITY_MESSAGE[messageArr[i]]) {
        feasibilityMessage = FEASBILITY_MESSAGE[messageArr[i]];
      }
    }
    return feasibilityMessage;
  };

  const fetchFeasibilityDataById = (feasibilityId: string) => {
    if (!feasibilityId) {
      return;
    }
    setShowLoader(true);
    checkOftFeasibilityStatusDedicated({ feasibilityId, product: getProductType(true) }, false, true).then(
      (res) => {
        setShowLoader(false);
        let feasibilityResponse: FeasibilityResponseType = res?.data?.result[0];
        if (!feasibilityResponse) {
          setErrorMessage(FEASBILITY_MESSAGE[feasibility_type.FEASIBILITY_ERROR]);
          return;
        }
        let messageKeys = feasibilityResponse?.message;
        const productType = getProductType(true);
        let message = getFeasibilityMessage(messageKeys, productType);
        if (message === FEASBILITY_MESSAGE[feasibility_type.FEASIBILITY_EXPIRED]) {
          const isFeasible = feasibilityResponse?.feasibilityStatus === FEASIBILITY_STATUS_SCHEMA.FEASIBLE;
          feasibilityResponse.feasibilityStatus = 'EXPIRED';
          setFeasibilityResponse(feasibilityResponse);
          // setInstAddressValidated(isFeasible);
          return;
        }
        if (message) {
          setErrorMessage(message);
          return;
        }
        if (!message) {
          const isFeasible = feasibilityResponse?.feasibilityStatus === FEASIBILITY_STATUS_SCHEMA.FEASIBLE;
          setFeasibilityResponse(feasibilityResponse);
          setErrorMessage(null);
          // setInstAddressValidated(isFeasible);
        }
        // else {
        //   setInstAddressValidated(false);
        // }
      },
      (error) => {
        setShowLoader(false);
        const errorMsg = (error && error.response && error.response.data && error.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;
        setErrorMessage(errorMsg);
      }
    );
  };

  const fetchFeasibilityData = useCallback(debounce(fetchFeasibilityDataById, 500), []);

  const onFeasibilityIDChange = (value: string) => {
    setForm({ feasibilityId: { ...form.feasibilityId, value } });
    resetState();
  };

  const onCheckClickHandelr = () => {
    fetchFeasibilityData(form.feasibilityId.value);
  };

  const createNewFeasibilityFromID = () => {
    const payLoad: CreateNewFeasibilityPayLoad = {
      product: getProductType(true),
      recommendedFeasibilityId: form.feasibilityId.value,
      requestedBandwidth: feasibilityResponse?.requestedBandwidth ? feasibilityResponse?.requestedBandwidth : 0,
      requestId: uuidv4(),
      source: 'B2B',
      feature: 'RE_USE_FEASIBILITY'
    };
    createNewFeasibilityFromId(payLoad, true).then(
      (resp) => {
        setShowLoader(false);
        const feasibilityResponse: FeasibilityResponseType = resp?.data?.result;
        setFeasibilityResponse(feasibilityResponse);
        const { pinCode: pincode } = feasibilityResponse?.address || {};
        processFeasibilityResponse?.({ feasibilityResponse, feasibilityCustomerDetails: { pincode, addressObj: feasibilityResponse?.address || {} } });
      },
      (err) => {
        setShowLoader(false);
        handleError(err);
      }
    );
  };

  const onProceed = () => {
    setShowLoader(true);
    const isExpiredOrPending = [FEASIBILITY_STATUS_SCHEMA.EXPIRED, FEASIBILITY_STATUS_SCHEMA.PENDING, FEASIBILITY_STATUS_SCHEMA.MANUAL_INTERVENTION_REQUIRED].includes(
      feasibilityResponse?.feasibilityStatus ?? ''
    );
    if (isExpiredOrPending) {
      processFeasibilityResponse?.({ feasibilityResponse, isExpiredOrPending });
    } else {
      createNewFeasibilityFromID();
    }
  };

  const isProceedDisabled = () => {
    return !form.feasibilityId.value || showLoader;
  };

  return (
    <>
      <div className="feasibility_id_details">
        <div className="field_group">
          <div className="field_area">
            <Input
              label="Feasibility ID"
              errors={form.feasibilityId.errors}
              touched={form.feasibilityId.touched}
              value={form.feasibilityId.value}
              onChange={onFeasibilityIDChange}
              maxLength={30}
              required
            />
            {errorMessage && form?.feasibilityId?.value && <p className="error-message"> {errorMessage}</p>}
          </div>
        </div>
        {feasibilityResponse?.feasibilityStatus && form.feasibilityId.value && (
          <NetworkStatus status={feasibilityResponse.feasibilityStatus} address={feasibilityResponse?.address?.addressString} />
        )}

        <div className="feasibility_info_text">
          {(feasibilityResponse?.feasibilityStatus === FEASIBILITY_STATUS_SCHEMA.EXPIRED ||
            feasibilityResponse?.feasibilityStatus === FEASIBILITY_STATUS_SCHEMA.MANUAL_INTERVENTION_REQUIRED ||
            feasibilityResponse?.feasibilityStatus === FEASIBILITY_STATUS_SCHEMA.PENDING) && (
            <p>
              Click on <b>"Proceed"</b> to create a new feasibility request with same installation details.
            </p>
          )}
          {feasibilityResponse ? 'Want a different installation address? ' : 'Don’t have a feasibility ID? '}
          <span className="link_text" onClick={() => setShowFeasibilityId(false)}>
            {' '}
            Enter new installation address
          </span>
        </div>
      </div>
      <div className="action_area">
        {!feasibilityResponse && (
          <Button disabled={!form.feasibilityId?.value || form.feasibilityId?.value?.length < 6 || showLoader} onClick={onCheckClickHandelr}>
            Check
            {showLoader && <span className="loading_icon"></span>}
          </Button>
        )}

        {feasibilityResponse && (
          <Button disabled={isProceedDisabled()} onClick={onProceed}>
            Proceed
            {showLoader && <span className="loading_icon"></span>}
          </Button>
        )}
      </div>
    </>
  );
};
